import { UserType } from "../shared/enums";

export class AuthResult {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export class PasswordReset {
    userId: number;
    newPassword: string;
    confirmPassword: string;
    resetToken: string;
}

export class RefreshTokenRequest {
    refresh_token: string;
}

export class AutoLoginRequest{
    userId: number;
    incidentId: number;
}

export class User {
    userId: number = 0;
    clientId: number = 0;
    lat: number = -28.5;
    lon: number = 24.6;
    username: string = '';
    userEmail: string = '';
    firstName: string = '';
    lastName: string = '';
    clientName: string = '';
    userType: UserType = UserType.unknown;
    isWhatsappOnlyNotificationRecipient: boolean = false;
    claims: string[] = [];
    clientTypes: number[] = [];
    userCell: string = '';
}

export class BreakdownTechnicianStatus extends User {
    statusId: number;
    dtLogged: string;
    latitude: number;
    longitude: number;
    clientEta: string;
    incidentId: number;
    incidentNumber: string;
    incidentStatusId: number;
    incidentDtLogged: string;
    incidentLatitude: number;
    incidentLongitude: number
}

export class BreakdownTechnicianStatusUpdate{
    statusId: number;
    latitude: number;
    longitude: number;
    clientEta: number;
    minutes: number;
}

export class UserLocation {
    userId: number;
    locationLatitude: number;
    locationLongitude: number
    locationDescription: string;
}

export class TechDriverLocation extends UserLocation {
    dtLogged: string;
}

export class DocumentCategory {
    categoryId: number;
    categoryName: string;
    categoryDescription: string;
}
